import { inject, Service } from '@angular/core';
import { type ActivatedRouteSnapshot, type RouterStateSnapshot } from '@angular/router';
import { type Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ContextService } from '@core/providers/context/context.service';
import { CONSTANTS } from '@shared/constants';

@Service()
export class ContextBreadcrumbLabelResolver {
  private readonly contextService = inject(ContextService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string | null> {
    const routeConfigPath = route.routeConfig?.path ?? '';
    const isVenueBaseRoute =
      routeConfigPath.startsWith(`${CONSTANTS.ROUTES.VENUE}/`) ||
      state.url.startsWith(`/${CONSTANTS.ROUTES.VENUE}/`);

    return this.contextService.getContext$().pipe(
      take(1),
      map(context => {
        const name = isVenueBaseRoute
          ? (context?.venueName ?? context?.accountName ?? null)
          : (context?.accountName ?? context?.venueName ?? null);
        if (typeof name !== 'string') {
          return null;
        }
        const trimmed = name.trim();
        return trimmed.length > 0 ? trimmed : null;
      })
    );
  }
}
